import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import banner_1 from "../pictures/banner_1.jpg";
import banner_2 from "../pictures/banner_2.jpg";
import banner_3 from "../pictures/banner_3.jpg";
import banner_4 from "../pictures/banner_4.jpg";
import banner_5 from "../pictures/banner_5.jpg";
import banner_6 from "../pictures/banner_6.jpg";
import banner_7 from "../pictures/banner_7.jpg";
import banner_8 from "../pictures/banner_8.jpg";
import banner_9 from "../pictures/banner_9.jpg";
import banner_10 from "../pictures/banner_10.jpg";
import banner_11 from "../pictures/banner_11.jpg";
import banner_12 from "../pictures/banner_12.jpg";



const Banner = () =>
{
    return(
        <>
        <Carousel
          className="home_carousel"
          infiniteLoop
          autoPlay
          showStatus={false}
          showThumbs={false}
          interval={2000}
          coverflowEffect
        >
          <div className="home_carousel_img">
            <img src={banner_1} alt="item-1" width={10} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_2} alt="item-2" width={500} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_3} alt="item-3" width={500} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_4} alt="item-3" width={500} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_5} alt="item-3" width={500} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_6} alt="item-3" width={500} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_7} alt="item-3" width={500} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_8} alt="item-3" width={500} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_9} alt="item-3" width={500} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_10} alt="item-3" width={500} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_11} alt="item-3" width={500} height={600} />
          </div>
          <div className="home_carousel_img">
            <img src={banner_12} alt="item-3" width={500} height={600} />
          </div>
        </Carousel>
        </>
    )
}

export default Banner;